<script>
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';

import { required, maxLength, minValue } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: ['vesselProtocolId', 'direction', 'referenceDate', 'isDisabled'],

  components: {
    Button,
    GenericDataTable,
    ResponsiveButton,
    GenericBooleanDropdown,
    GenericCustomMasterDataAutocompleteV2
  },
  data() {
    return {
      data: {},
      filters: [],
      addPaymentDialogVisible: false,
      newPayment: {
        isSpecialPayment: false,
        isPeriodicPayment: false,
      },
      config: {},
      newPaymentSubmitted: false,
      showExportPortualTaxReport: false,
      documents: [],
      emailDialogVisible: false,
      selectedPaymentId: null,
      mailAddresses: ""
    }
  },
  validations() {
    return {
      newPayment: {
        idPaymentType: { required }
      },
    }
  },
  computed: {
    constants() {
      return CommonConstants;
    },
    utils() {
      return Utils;
    },
    uiPermissions() {
      return this.$store.getters['security/uiPermissions'];
    },
  },
  created() {
    this.config = config.getConfiguration('VesselProtocol');
    if (this.isDisabled) {
      this.config.paymentsTable.enableInlineEdit = false;
      this.config.paymentsTable.enableDelete = false;
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    "newPayment.isSpecialPayment"(newValue) {
      if (newValue) {
        this.newPayment.isPeriodicPayment = false;
        this.newPayment.dueDate = Utils.formatDatePlusDays(Utils.formatDatePlusMonths(new Date(this.newPayment.referenceDate), 1), -1);
      }
    },
    "newPayment.isPeriodicPayment"(newValue) {
      if (newValue) {
        this.newPayment.isSpecialPayment = false;
        this.calculateDueDate();
      }
    },
    "newPayment.a98Number"() {
      if (this.newPayment.a98Number && this.newPayment.a98Date) {
        this.newPayment.isExecuted = true;
      }
    },
    "newPayment.a98Date"() {
      if (this.newPayment.a98Number && this.newPayment.a98Date) {
        this.newPayment.isExecuted = true;
      }
    },
    'newPayment.referenceDate'() {
      if (this.newPayment.isPeriodicPayment) {
        this.calculateDueDate();
      } else if (this.newPayment.isSpecialPayment) {
        this.newPayment.dueDate = Utils.formatDatePlusDays(Utils.formatDatePlusMonths(new Date(this.newPayment.referenceDate), 1), -1);
      }
    },
    referenceDate(newValue) {
      this.newPayment.referenceDate = newValue;
    },
    isDisabled(newValue) {
      this.config.paymentsTable.enableInlineEdit = !newValue;
      this.config.paymentsTable.enableDelete = !newValue;
    },
    addPaymentDialogVisible(newValue) {
      if (!newValue) {
        this.newPayment = {
          isSpecialPayment: false,
          isPeriodicPayment: false,
          referenceDate: this.referenceDate
        };
        this.newPaymentSubmitted = false;
      }
    }
  },
  methods: {
    loadData() {
      this.filters = [
        {
          operator: 'eq',
          value: this.vesselProtocolId,
          property: 'IdVesselProtocol'
        }
      ];
      this.$refs.paymentsTable.filterFromView(this.filters);
    },
    calculateDueDate() {

      try {
        let month = new Date(this.newPayment.referenceDate).getMonth() + 1;
        let day = new Date(this.newPayment.referenceDate).getDate();

        if (month >= 1 && month <= 11) {
          if (day >= 1 && day <= 15) {
            this.newPayment.dueDate = new Date(Utils.formatDatePlusMonths(new Date(this.newPayment.referenceDate), 1).setDate(8));
          } else {
            this.newPayment.dueDate = new Date(Utils.formatDatePlusMonths(new Date(this.newPayment.referenceDate), 1).setDate(23));
          }
          console.log(this.newPayment.dueDate)
        } else {
          if (day >= 1 && day <= 24) {
            let date = new Date(new Date(this.newPayment.referenceDate).setDate(30));
            let dayOfTheWeek = date.getDay();

            if (dayOfTheWeek === 6) {
              this.newPayment.dueDate = new Date(Utils.formatDatePlusDays(date, -1))
            } else if (dayOfTheWeek === 7) {
              this.newPayment.dueDate = new Date(Utils.formatDatePlusDays(date, -2))
            }

          } else {
            this.newPayment.dueDate = new Date(Utils.formatDatePlusMonths(new Date(this.newPayment.referenceDate), 1).setDate(23));
          }
        }
      }
      catch (e) {
        console.log('errore', e)
      }
    },
    addPayment() {
      this.newPaymentSubmitted = true;

      if (!this.v$.newPayment.$invalid) {
        this.newPayment.idVesselProtocol = this.vesselProtocolId;
        this.newPayment.isDueDateModifiable = false;
        Service.addVesselProtocolPayment(this.newPayment, response => {
          if (response.success) {
            this.addPaymentDialogVisible = false;
            this.loadData();
            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000 });
          } else {
            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      }
    },
    updateData({ newData, data }) {

      if (newData.isSpecialPayment) {
        newData.isPeriodicPayment = false;
      }
      if (newData.isPeriodicPayment) {
        newData.isSpecialPayment = false;
      }
      this.newPayment.isDueDateModifiable = false;

      let sameData = Object.entries(data).every(([key, value]) => value === newData[key])

      if (!sameData) {
        Service.updateVesselProtocolPayment(newData, response => {
          if (response.success) {
            this.loadData();
            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
          } else {
            this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        });
      }
    },
    exportPortualTaxReport() {
      this.$store.dispatch("generic/setLoading", true);
      Service.saveVesselProtocolPortualTaxReport({ isPreview: true, data: { idVesselProtocol: this.vesselProtocolId } }, ({ success, data, message }) => {
        if (success) {
          Service.getPreviewVesselProtocolReport({ id: data.id }, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if (response.success) {
              var fileURL = window.URL.createObjectURL(new Blob([response.data]));
              var fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Portual-Tax-Report.pdf');
              document.body.appendChild(fileLink);
              fileLink.click();
            } else {
              this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
          })
        } else {
          this.$store.dispatch("generic/setLoading", false);
          this.$toast.add({ detail: message && message != '' ? message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
    showPaymentMailDialog(data) {
      this.selectedPaymentId = data.id;
      this.$store.dispatch("generic/setLoading", true);
      this.showAddress();
      Service.getAttachmentsByIdVesselProtocol(this.vesselProtocolId, ({ success, data, message }) => {
        this.$store.dispatch("generic/setLoading", false);
        if (success) {
          this.documents = data;
          this.emailDialogVisible = true;
        } else {
          this.documents = [];
          this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
    sendPaymentEmail() {
      this.$store.dispatch("generic/setLoading", true);

      let idList = this.documents.filter((document) => document.check).map((item) => item.id);

      // let body = {
      //   idList: idList,
      //   guiIdDocument : this.lastLoaded
      // }
      Service.sendEmailPaymentsVesselProtocol(this.selectedPaymentId, idList, ({ success, message }) => {
        this.$store.dispatch("generic/setLoading", false);

        if (success) {
          this.loadData();
          this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.operation_message_success'), life: 3000 });
          this.emailDialogVisible = false;
        } else {
          this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
        }
      })
    },
    toggleAddress(event) {
      this.$refs.op.toggle(event)
    },
    showAddress() {
      let params = {
        paymentId: this.selectedPaymentId,
        idVesselProtocol: this.vesselProtocolId
      }
      this.mailAddresses = { value: "", escape: true };
      Service.getReportDataAddress(params, response => {
        if (response.success) {
          this.mailAddresses.value = "<div style='width: 300px'>";

          let to = response.data.to;
          if (to && to.length > 0) {
            this.mailAddresses.value += "TO: ";
            for (let i = 0; i < to.length; i++) {
              this.mailAddresses.value += '<br> - ' + to[i];
            }
          }
          let cc = response.data.cc;
          if (cc && cc.length > 0) {
            this.mailAddresses.value += "<br>CC: ";
            for (let i = 0; i < cc.length; i++) {
              this.mailAddresses.value += '<br> - ' + cc[i];
            }
          }
          let ccn = response.data.bcc;
          if (ccn && ccn.length > 0) {
            this.mailAddresses.value += "<br>CCN: ";
            for (let i = 0; i < ccn.length; i++) {
              this.mailAddresses.value += '<br> - ' + ccn[i];
            }
          }
          this.mailAddresses.value += "</div>";
        }
      })
    }
  },
}

</script>

<template>
  <main>
    <Dialog v-model:visible="emailDialogVisible" modal closable :style="{ width: '60vw' }">
      <template #header>
        <h3>{{ $t('vesselProtocol.paymentsEmail') }}</h3>
        <Button icon="pi pi-info" severity="success" text raised rounded @click="toggleAddress" />
        <OverlayPanel ref="op">
          <div v-html="mailAddresses.value" />
        </OverlayPanel>
      </template>
      <div class="grid">
        <div class="field col-12">
          <hr :style="{ marginTop: '0' }">
          <p>{{ this.$t('vesselProtocol.paymentsEmailInformation') }}</p>
          <p>{{ this.$t('vesselProtocol.proceedToSend') }}</p>
          <hr :style="{ marginBottom: '0' }">
        </div>
        <div class="field col-12">
          <b>{{ this.$t('vesselProtocol.documentsToAttach') }}</b>
          <template v-for="document in documents" :key="document.id">
            <p>
              <Checkbox v-model="document.check" :binary="true" />
              <label class="ml-2">{{ document.documentType }}</label>
            </p>
          </template>
        </div>
      </div>
      <template #footer>
        <ResponsiveButton :label="$t('vesselProtocol.sendNow')" icon="pi pi-check" class="p-button-outlined"
          @click="sendPaymentEmail" />
        <ResponsiveButton :label="$t('vesselProtocol.sendLater')" icon="pi pi-times"
          class="p-button-danger p-button-outlined" @click="emailDialogVisible = false" />
      </template>
    </Dialog>
    <Dialog :header="$t('vesselProtocol.addPayment')" v-model:visible="addPaymentDialogVisible" :style="{ width: '90vw' }"
      :modal="true">
      <div class="grid">
        <template v-for="field in config.paymentsTable.columns" :key="field.name">
          <div class="col-12 lg:col-4" v-if="!field.formHide">
            <label
              :class="{ 'p-error': v$.newPayment[field.name] && v$.newPayment[field.name].$invalid && newPaymentSubmitted }"
              :for="field.name">{{ $t(field.label) }}</label>
            <InputText v-if="field.type === 'string'"
              :class="{ 'p-invalid': v$.newPayment[field.name] && v$.newPayment[field.name].$invalid && newPaymentSubmitted }"
              :id="field.name" type="text" v-model="newPayment[field.name]" class="w-full p-inputtext-sm mt-1" />
            <Calendar :dateFormat="constants.DATE_FORMAT_POINT" :showIcon="true" :showButtonBar="true"
              :yearNavigator="true" v-if="field.type === 'date'"
              :class="{ 'p-invalid': v$.newPayment[field.name] && v$.newPayment[field.name].$invalid && newPaymentSubmitted }"
              :id="field.name" v-model="newPayment[field.name]" class="w-full mt-1" />
            <InputNumber v-if="field.type === 'number'"
              :class="{ 'p-invalid': v$.newPayment[field.name] && v$.newPayment[field.name].$invalid && newPaymentSubmitted }"
              :id="field.name" v-model="newPayment[field.name]" class="w-full p-inputtext-sm mt-1" />
            <InputNumber v-if="field.type == 'decimal'"
              :class="{ 'p-invalid': v$.newPayment[field.name] && v$.newPayment[field.name].$invalid && newPaymentSubmitted }"
              mode="decimal" :maxFractionDigits="field.digits" :id="field.name" v-model="newPayment[field.name]"
              class="w-full p-inputtext-sm m-1" />
            <GenericBooleanDropdown v-if="field.type === 'boolean'" v-model="newPayment[field.name]" class="w-full" />
            <textarea v-if="field.type === 'textarea'"
              :class="{ 'p-invalid': v$.newPayment[field.name] && v$.newPayment[field.name].$invalid && newPaymentSubmitted }"
              :id="field.name" v-model="newPayment[field.name]" class="w-full p-inputtext-sm mt-1" />
            <GenericCustomMasterDataAutocompleteV2 v-if="field.type == 'select'" :name="field"
              v-model="newPayment[field.name]" :api="field.selectApi" />
            <div
              v-if="(v$.newPayment[field.name] && v$.newPayment[field.name].$invalid && newPaymentSubmitted) || v$.newPayment[field.name] && v$.newPayment[field.name].$pending.$response">
              <small class="p-error"
                v-for="error in v$.newPayment[field.name] && v$.newPayment[field.name].$silentErrors"
                :key="error.$validator">
                {{ error.$message }}
              </small>
            </div>
          </div>
        </template>
        <div class="col-12 text-right">
          <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" @click="addPaymentDialogVisible = false"
            class="p-button-outlined p-button-sm" />
          <ResponsiveButton :label="$t('btn.confirm')" icon="pi pi-check" @click="addPayment"
            class="p-button-outlined p-button-sm ml-2" />
        </div>
      </div>
    </Dialog>
    <div class="grid">
      <div class="col-12">
        <Toolbar>
          <template #start>
            <Button :label="$t('btn.add')" icon="pi pi-plus" class="p-button-success"
              @click="addPaymentDialogVisible = true"
              :disabled="!uiPermissions('vesselProtocolPaymentsAddButton').isEnabled || isDisabled"
              v-if="!uiPermissions('vesselProtocolPaymentsAddButton').isHidden" />
            <Button :label="$t('vesselProtocol.exportReportPortualTax')" icon="pi pi-file" class="p-button-primary ml-3"
              @click="exportPortualTaxReport" v-if="showExportPortualTaxReport" />
          </template>
        </Toolbar>
      </div>
      <div class="col-12">
        <GenericDataTable :configuration="config.paymentsTable" ref="paymentsTable" :onCellEditComplete="updateData"
          @onLoadComplete="(data) => { showExportPortualTaxReport = data.some(({ idPaymentType }) => idPaymentType === 1) }"
          @on-show-payment-email-dialog="showPaymentMailDialog" />
      </div>
    </div>
  </main>
</template>
